module.exports = {"130274103":"唐山海港开发区王滩镇","130274451":"唐山海港经济开发区街道","130274452":"唐山湾国际旅游岛","130274455":"大清河"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130274.json
// module id = 96
// module chunks = 0